import type {
  ObjectToolbarConfig,
  RegisterToolbarConfigArgs,
} from '@/blocks/object-toolbar';

/**
 * Assemble the object-toolbar config for the Acceptances register/list page
 * (CUS-158). Register toolbars are type-level: no `parentObject` (permissions
 * resolve against the type) and no `save` (a list page has no form). The
 * register's multi-format export (CSV / PDF / custom PDF) is surfaced as the
 * toolbar's "Download" group — one action per `ExportOption` returned by
 * `useExportOptions`, the same source that drives the legacy `ExportButton`.
 * Acceptances' register is export-only (creation happens from a risk's detail
 * page), so it never supplies `create`.
 *
 * Takes the shared {@link RegisterToolbarConfigArgs} (see
 * `blocks/object-toolbar/types.ts`). Pure so it can be unit-tested without
 * rendering the page.
 */
export const buildAcceptanceRegisterToolbarConfig = ({
  title,
  counter,
  exportOptions,
  editRibbon,
}: RegisterToolbarConfigArgs): ObjectToolbarConfig => ({
  header: { title, counter },
  actions: {
    ...(editRibbon
      ? {
          overflow: [
            {
              id: 'edit',
              label: editRibbon.groupLabel,
              actions: [
                {
                  id: 'edit-ribbon',
                  label: editRibbon.label,
                  iconName: 'filter-lines',
                  onClick: editRibbon.onClick,
                },
              ],
            },
          ],
        }
      : {}),
    export: [
      {
        id: 'export',
        actions: exportOptions.map((option) => ({
          id: option.id,
          label: option.text,
          iconName: 'download-01',
          onClick: option.exportFunction,
          disabled: option.disabled,
        })),
      },
    ],
  },
});
